var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridiconsVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9V7C17.5 6.46957 17.2893 5.96086 16.9142 5.58579C16.5391 5.21071 16.0304 5 15.5 5H4.5C3.96957 5 3.46086 5.21071 3.08579 5.58579C2.71071 5.96086 2.5 6.46957 2.5 7V17C2.5 17.5304 2.71071 18.0391 3.08579 18.4142C3.46086 18.7893 3.96957 19 4.5 19H15.5C16.0304 19 16.5391 18.7893 16.9142 18.4142C17.2893 18.0391 17.5 17.5304 17.5 17V15L22.5 19V5L17.5 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsVideo);
export default __webpack_public_path__ + "static/media/gridicons_video.71216a08b544f0caa04c39fcf9031161.svg";
export { ForwardRef as ReactComponent };